import { Section, SectionHeading } from "@/components/ui";
import { ALLIANCES } from "@/data/about";

/** Partner logos in an endless left-scrolling strip (duplicated track, no pause between loops). */
export function AlliancesSection() {
  const loop = [0, 1];

  return (
    <Section tone="brandTint" labelledBy="about-alliances-title" testId="about-alliances" spacing="compact">
      <div className="relative z-10">
        <SectionHeading id="about-alliances-title" title={ALLIANCES.title} />

        <div className="mt-8 overflow-hidden motion-reduce:overflow-x-auto" data-testid="about-alliances-carousel">
          <div className="flex w-max animate-marquee motion-reduce:animate-none">
            {loop.map((copy) => (
              <ul key={copy} className="flex shrink-0 items-stretch" aria-hidden={copy === 1 ? "true" : undefined}>
                {ALLIANCES.partners.map((partner) => (
                  <li key={`${copy}-${partner.id}`} className="w-44 shrink-0 pr-3 sm:w-52 sm:pr-4 lg:w-56">
                    <div className="flex h-full min-h-[5.5rem] items-center justify-center rounded-3xl border border-brand-100 bg-white p-3 sm:min-h-[6rem] sm:p-4">
                      <img
                        src={`${process.env.PUBLIC_URL}/${partner.file}`}
                        alt={copy === 0 ? partner.name : ""}
                        width={420}
                        height={145}
                        loading="lazy"
                        decoding="async"
                        className="h-auto max-h-16 w-full object-contain sm:max-h-[4.5rem]"
                      />
                    </div>
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}
